import moment from 'moment'
import React, { useState } from "react";
import { PIFlowLeftNavBar } from "../../ReusableComp/NavBarLeft";
import NavigationBar from "../../ReusableComp/NavigationBar";
import { Accordion, Col, Container, Row } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { toast } from 'react-toastify';
import Loader from '../../ReusableComp/Loader';
import PopUpModal from "../../ReusableComp/PopUpModal";
import BrightonCase from '../SubjectFlow/BrightonCase';
import GradeCase from '../SubjectFlow/GradeCase';
import { FaEye, FaDownload, FaTimes } from 'react-icons/fa';
import { Modal, Button } from 'react-bootstrap';

import {
  getEventDetails,
  getSubjProfDetails,
  getReviewerComments,
  getStudyAeDetailsSimplified,
  getAllCausalities,
  getAllOutComes,
  getActionTaken,
  getActionTakenForAE,
  getSAdvEvents,
  resetEventDetails,
  resetSubjectProfile
} from "../../../Redux/actions/actions";
import {
  base_url,
  EVENT_CLASSIFICATION_AESI,
  EVENT_CLASSIFICATION_LEVEL_BRIGHTON,
  EVENT_CLASSIFICATION_GRADE_CTCAE,
  EVENT_CLASSIFICATION_OTHER,
  EVENT_STATUS_WAITING_FOR_REVIEW,
  PRINCIPAL_INVESTIGATOR,
  MEDICAL_REVIEWER,
  QUALITY_REVIEWER
} from "../../../utilities";
import axios from "../../../axios-interceptor";


const PIRejectEventsEdit = () => {
  const dispatch = useDispatch()
  const location = useLocation();
  const navigate = useNavigate();
  const stateData = location.state.data;
  const eventDtls = location.state.eventDtls;
  const subjDetails = useSelector((state) => state.getSubProf);
  const reviewerComments = useSelector((state) => state.reviewerComments);
  const getStudyAeDtls = useSelector((state) => state.getStudyAeDtls)
  const saEvents = useSelector((state) => state.getSAEvents);
  const causalities = useSelector((state) => state.getCausalities);
  const outComes = useSelector((state) => state.getOutComes);
  const actnTakenOpts = useSelector((state) => state.actionTaken);
  const actionTakenforAe = useSelector((state) => state.actionTakenforAe);
  const [radioValue, setRadioValue] = useState(eventDtls.event_description_id)
  const [radioReset, setRadioReset] = useState('')
  const [eventDesc, setEventDesc] = useState()
  const [valuForDisble, setValuForDisble] = useState()
  const JustBtwn = "d-flex justify-content-between";
  const [open, setOpen] = React.useState(false);
  const minDateofOnset = subjDetails && subjDetails["SubjectDoses.date_of_administration"]
  const [today, setToday] = useState('');
  const [treatmentGiven, setTreatmentGiven] = useState(eventDtls?.any_treatment_given);
  const [notesChange, setNotesChange] = useState(eventDtls?.input_notes_aesi_others);
  const [searchTerm, setSearchTerm] = useState("");
  const [btnTitle, setBtnTitle] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [seriousAE, setSeriousAE] = useState({});
  const [defaultValues, setDefaultValues] = useState({})
  const [studyDropdwn, setStudyDropdwn] = useState(false);
  const [studyOption, setStudyOption] = useState();
  const [loading, setLoading] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [flag, setFlag] = useState(true);
    const [selectedSubject, setSelectedSubject] = useState(null);
    const [actionAdverse, setActionAdverse] = useState("Select");
    const [selectedOption, setSelectedOption] = useState('Select');
    const subjectProfile = useSelector((state) => state.getSubProf);
    let extensions=""
    const [buttonDisable,setButtonDisable] = useState(false)



  useEffect(() => {
    const currentDate = new Date();
    const formattedDate = currentDate.toDateString();
    setToday(formattedDate);
  }, [today]);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        dispatch(getEventDetails(stateData))
        dispatch(getSubjProfDetails({ "subject_id": stateData.subject_id, "dose": stateData.dose }))
        dispatch(getReviewerComments({
          adverse_event_mapping_id: stateData?.adverse_event_id
        }))
        dispatch(getSAdvEvents())
        dispatch(getAllCausalities())
        dispatch(getAllOutComes())
        dispatch(getActionTaken())
        dispatch(getActionTakenForAE())
      } catch (error) {
        console.log(error)
      }
    };
    fetchData()
  }, [dispatch]);

  useEffect(() => {
    if (eventDtls) {
      dispatch(getStudyAeDetailsSimplified({
        case_def: eventDtls?.study_case_definition,
        value: eventDtls?.study_aebank_id
      }));
      setDefaultValues({
        dateOfOnset: eventDtls?.date_of_onset,
        dateOfResolution: eventDtls?.date_of_resolution,
        timeOfOnset: eventDtls?.time_of_onset,
        timeOfResolution: eventDtls?.time_of_resolution,
        causality_id: eventDtls?.causality_id,
        outcome_id: eventDtls?.outcome_id,
        action_taken_for_adverse_event_id: eventDtls?.action_taken_for_adverse_event_id,
        action_taken_id: eventDtls?.action_taken_id,
        start_date_of_treatment: eventDtls?.start_date_of_treatment,
        end_date_of_treatment: eventDtls?.end_date_of_treatment
      });
      if(eventDtls?.action_taken_for_adverse_event_name==="Surgical Treatment" ||
      eventDtls?.action_taken_for_adverse_event_name==="Medical Treatment"){
      setFlag(false);
  }
  else{
      setFlag(true);
  }
      setNotesChange(eventDtls?.input_notes_aesi_others);
      setRadioValue(eventDtls?.event_description_id);
      setLoading(false);
    }

  }, [eventDtls])

  useEffect(() => {
    setLoading(true)
    if (subjDetails && eventDtls) {
      setLoading(false)
    }
  },[subjDetails,eventDtls])

  const getRoleCode = (data) => { };

  const handleStudyChange = () => {

  };

  const handleOptionChange = (e, key, value) => {
    setStudyOption(value);
  };

  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
  };

  const handleReset = () => {
    setRadioReset('')
  }

  function getEventDescId(val) {
    if (val) {
      setEventDesc(val)
      setValuForDisble(val)
    }
  }

  function handleRadioBtn(val) {
    setRadioValue(val)
  }

  const handleClosePopup = () => {
    setOpen(false);
    window.location.reload();
  };

  const handleNotesChange = (e) => {
    setNotesChange(e.target.value)
  }

  function handleDropDown() {
    setShowPopup(!showPopup)
    setSearchTerm('');
  }

  const handleTreatment = (e) => {
    let value = e.target.value;
    if (value !== '') { setTreatmentGiven(value) }
    else { setTreatmentGiven('') }
  }

  const handleDefaultValuesChange = e => {
    const { name, value } = e.target;
    const selectedValue = e.target.value;
    if (selectedValue === "Select") {
        setFlag(true);
    }
    setSelectedOption(selectedValue);
    for (var i = 0; i < actionTakenforAe.length; i++) {
        var currentObject = actionTakenforAe[i];
        if (currentObject.action_taken_for_adverse_event_id === selectedValue) {
            setActionAdverse(currentObject.action_taken_for_adverse_event_name)
            if (currentObject.action_taken_for_adverse_event_name === "None") {
                setFlag(true);
                setButtonDisable(false)
                setDefaultValues({...defaultValues,start_date_of_treatment:null,end_date_of_treatment:null})
            }
            else {
                setButtonDisable(true)
                setFlag(false)
            }
        }
    }
    setDefaultValues(prev => ({
      ...prev,
      [name]: value,
    }))
    if (name === 'timeOfOnset' || name === 'dateOfOnset') {
      setDefaultValues((prevValues) => ({
        ...prevValues,
        dateOfResolution: '',
        timeOfResolution: '',
        start_date_of_treatment: '',
        end_date_of_treatment: '',
      }));
    }
  }

  function handleSearch(e) {
    setSearchTerm(e.target.value);
  }

  function handleOption(e) {
    setSearchTerm(e.serious_adverse_event_name);
    setShowPopup(false)
    setBtnTitle(e.serious_adverse_event_name)
    setSeriousAE({
      label: e.serious_adverse_event_name,
      value: e.serious_adverse_event_id,
    })
  }

  const handleReviewActions = () => {
    navigate('/pirejectedevents');
    window.location.reload()
  }
  function calculateBMI(weight, height) {
    if (isNaN(weight) || isNaN(height) || height === null) {
        return "0"; // Display "N/A" if either weight or height is not a number
    }
    const bmi = weight / ((height / 100) ** 2);

    return bmi.toFixed(1);
}

  const handleUpdate = () => {
    let updateObj = {
      "pi_id": localStorage.pi_id,
      "adverse_event_mapping_id": eventDtls.adverse_event_mapping_id,
      "subject_id": subjDetails.subject_id,
      "subject_dose_id": subjDetails['SubjectDoses.subject_dose_id'],
      "study_id": subjDetails.study_id,
      "date_of_onset": defaultValues.dateOfOnset,
      "time_of_onset": defaultValues.timeOfOnset,
      "date_of_resolution": defaultValues.dateOfResolution,
      "start_date_of_treatment": defaultValues.start_date_of_treatment,
      "end_date_of_treatment": defaultValues.end_date_of_treatment,
      "time_of_resolution": defaultValues.timeOfResolution,
      "causality_id": defaultValues.causality_id,
      "outcome_id": defaultValues.outcome_id,
      "action_taken_id": defaultValues.action_taken_id,
      "action_taken_for_adverse_event_id": defaultValues.action_taken_for_adverse_event_id,
      "event_description_id": eventDesc && eventDesc.event_description_id,
      "is_case_meets": eventDesc && eventDesc.is_case_meets,
      "input_notes_aesi_others": notesChange,
      "any_treatment_given": treatmentGiven,
      "serious_adverse_event_id": seriousAE.value,
      "updated_by": localStorage.login_user_name
    }
    axios
      .post(base_url + "principal-investigator/update_adverse_event", updateObj)
      .then((res) => {
        if (res.data.data.errors) {
          if (res.data.data.errors[0].message) {
            toast.error(`${res.data.data.errors[0].message}`, {
              toastId: 2
            })
          }
        }
        else {
          setOpen(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const handleViewClick = (document) => {
    setSelectedDocument(document);
  };

   // Handle Start Date change
   const handleStartDateChange = (e) => {
    const newStartDate = e.target.value;
    setDefaultValues({
        ...defaultValues,
        start_date_of_treatment: newStartDate,
        end_date_of_treatment: "",
    });
};

// Handle End Date change
const handleEndDateChange = (e) => {
    const newEndDate = e.target.value;
    setDefaultValues({
        ...defaultValues,
        end_date_of_treatment: newEndDate,
    });
};
function getIcon(fileExtension) {
  switch (fileExtension) {
    case 'pdf':
      return "./images/icons/reshot-icon-pdf.svg"
    case 'ppt':
      return "./images/icons/reshot-icon-ppt.svg"
    case 'txt':
      return "./images/icons/reshot-icon-txt.svg"
    case 'docx':
      return "./images/icons/reshot-icon-docx.svg"
    case 'doc':
      return "./images/icons/reshot-icon-doc.svg"
    case 'xls':
      return "./images/icons/reshot-icon-xls.svg"
    case 'csv':
      return "./images/icons/reshot-icon-csv.svg"
    case 'jpg':
      return "./images/icons/reshot-icon-jpg.svg"
    case 'png':
      return "./images/icons/reshot-icon-png.svg"
    case 'jpeg':
      return "./images/icons/reshot-icon-jpeg.svg"
   }
}
const handleOpenModal = (document) => {
  setSelectedDocument(document);
};

const handleCloseModal = () => {
  setSelectedDocument(null);
};
const isImage = (url) => {
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
  return imageExtensions.includes(url);
};

const [timeError, setTimeError] = useState("");
  const [showTimeError, setShowTimeError] = useState(false)

  function validateTimeOfResolution(event) {
    const inputTime = event.target.value;
    const timeOfOnset = defaultValues.timeOfOnset;
  
    if (timeOfOnset) {
      // Convert input times to minutes for comparison
      const inputTimeMinutes = timeStringToMinutes(inputTime);
      const timeOfOnsetMinutes = timeStringToMinutes(timeOfOnset);
  
      if (inputTimeMinutes < timeOfOnsetMinutes) {
        const val = "Select time after "+defaultValues.timeOfOnset
        setTimeError(val)
        setShowTimeError(true)
        // If the input time is before the time of onset, clear the input
        event.target.value = '';
      }
      else{
        setTimeError("val")
        setShowTimeError(false)
      }
    }
  }
  
  
  function timeStringToMinutes(timeString) {
    const [hours, minutes] = timeString.split(':').map(Number);
    return hours * 60 + minutes;
  }
  return (
    <>
      <div>
        <NavigationBar
          studyDropdwn={studyDropdwn}
          title={'Adverse Event: ' + eventDtls.study_aebank_event_title}
          rolecode={getRoleCode}
          handleOptionChange={handleOptionChange}
          handleFilteredData={handleStudyChange}
        />
        {/* <PIFlowLeftNavBar /> */}
        <div className="main_body ">
          { !loading && subjDetails && eventDtls &&
            <Container fluid className="p-0">
            <Row className="SVdtl_Main custm_pdng_aedtls flex-nowrap">
              <Col lg={4} className="section_1">
                {subjDetails &&
                  <div className="pisubj_left_main">
                    <div className="review_min_high review_min_highmbl">
                      <div className="p-3 body_cls s2 studydtlsmbl">
                        <div style={{ width: "100%", backgroundColor: "white", padding: "12px ", borderRadius: "8px" }}>
                          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                            <div>
                              <b>{'Dose '}{subjDetails["SubjectDoses.dose"]}</b>
                            </div>
                            <div>
                              <p>{''}</p>
                            </div>
                          </div>
                          <div>
                            <p style={{ paddingB: "0px", margin: "12px 0px 0px 0px" }}>
                              {"Date of administration: "} {moment(subjDetails["SubjectDoses.date_of_administration"]).format("DD-MM-YYYY")}
                            </p>
                          </div>
                        </div>

                        <div style={{ padding: "12px" }}>

                          <h6 className='mb-3'>{subjDetails?.subject_code}</h6>

                                                                                          <div className="row">
    <div className="col-6 p-0">
        <div className="mb-0">
            <span className="mb-0">Age:</span> <span className="space_yrs highlet-left">{subjectProfile?.age} Yrs</span>
        </div>
    </div>
    <div className="col-6">
        <div className="mb-0">
            <span className="mb-0">Height:</span> <span className='space_height highlet-left'>{subjectProfile?.height ? subjectProfile.height : 0} cm</span>
        </div>
    </div>
</div>
<div className="row">
    <div className="col-6 p-0">
        <div className="mb-0">
            <span className="mb-0">Gender:</span> <span className='highlet-left'>{subjectProfile?.sex}</span>
        </div>
    </div>
    <div className="col-6">
        <div className="mb-0">
            <span className="mb-0">Weight:</span> <span className='highlet-left'>{subjectProfile?.weight}Kg</span>
        </div>
    </div>
</div>
<div className="row">
    <div className="col-12 p-0">
        <div className="mb-0">
            <span className="mb-0">BMI:</span> <span className="space_bmi highlet-left">{calculateBMI(subjectProfile?.weight, subjectProfile?.height)} (BMI)</span>
        </div>
    </div>
</div>
                                                </div>



                        <div className="d-flex justify-content-between w-100" style={{ padding: "12px" }}>

                          <h6 className="site_add">
                            {subjDetails['Site.site_address']}
                          </h6>
                          <img
                            className=""
                            src="./images/icons/location.svg"
                            alt="Location Icon"
                          />
                        </div>
                        <div style={{ padding: "8px" }}>
                          <p>
                        {subjDetails.updatedAt ? (
                          `Last updated at - ${new Date(subjDetails.updatedAt).toLocaleDateString('en-US', options)}`
                        ) : (
                          'Last updated date unavailable'
                        )}
                      </p>
                        </div>
                      </div>
                      <div className=" px-md-3 s2 overflow-auto">
                          {reviewerComments && reviewerComments?.filter(i => i.user_persona === QUALITY_REVIEWER).length > 0 && 
                        <div className="studytab">
                          <span className="text-start">
                            Quality Reviewer Comments
                          </span>
                          {reviewerComments && reviewerComments?.filter(
                            i => i.user_persona === QUALITY_REVIEWER
                          ).map((i, index) => {
                            return (
                              <div key={index}>

                                <div className="qr_cmts_txt d-flex flex-row">
                                  <li></li>
                                  <div>{i.comment}</div>
                                </div>
                                <span className="qr_cmts_date ">
                                  By : {i.created_by} {", "} On :{" "} 
                                  {moment(i.createdAt).format("DD/MM/YYYY HH:mm:ss")}
                                </span>
                              </div>

                            );
                          })
                          }
                        </div>}



                          {reviewerComments && reviewerComments?.filter(i => i.user_persona === MEDICAL_REVIEWER).length > 0 && 
                        <div className="studytab">
                          
                          <span className="text-start">
                            Medical Reviewer Comments
                          </span>
                          {reviewerComments && reviewerComments?.filter(
                            i => i.user_persona === MEDICAL_REVIEWER
                          ).map((i, index) => {
                            return (
                              <div key={index}>

                                <div className="qr_cmts_txt d-flex flex-row">
                                  <li></li>
                                  <div>{i.comment}</div>
                                </div>
                                <span className="qr_cmts_date ">
                                  By : {i.created_by} {", "} On :{" "} 
                                  {moment(i.createdAt).format("DD/MM/YYYY HH:mm:ss")}
                                </span>
                              </div>

                            );
                          })
                          
                          }
                        </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </Col>

              <div className="col review_event_header pisub">
                <div className='title_cls right_cntnt right_cntntmbl'>
                  <h5 className="mb-1">Event</h5>

                </div>

                <Col className="py-1 px-md-4 py-md-3 qr_right_content">
                  <div className="d-lg-flex justify-content-between ">

                    <div className="">
                      <label htmlFor="dateOfonSet" className="custm_label_fw">
                        Date of onset
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        value={defaultValues.dateOfOnset}
                        className="customInput "
                        id="dateOfOnset"
                        type="date"
                        name="dateOfOnset"
                        min={minDateofOnset}
                        max={moment(today).format("YYYY-MM-DD")}
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{
                          padding: "16px 12px",
                          width: "340px",
                          cursor: "not-allowed",
                        }}
                        onChange={handleDefaultValuesChange}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                      {defaultValues.dateOfOnset?null:
                      <span className="placeholder-span" style={{width:"120px", height:"22px"}}>dd-mm-yyyy</span>
                      }
                    </div>

                    <div className="">
                      <label htmlFor="timeOfonSet" className="custm_label_fw">
                        Time of onset (24 Hrs)
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        value={defaultValues.timeOfOnset}
                        className="customInput "
                        id="timeOfOnset"
                        type="time"
                        name="timeOfOnset"
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "16px 12px", width: "340px" }}
                        onChange={handleDefaultValuesChange}
                      />
                      {defaultValues.timeOfOnset?null:
                      <span className="placeholder-span" style={{width:"40px", height:"22px"}}>--:--</span>
                      }
                    </div>
                  </div>
                  <div className="d-lg-flex justify-content-between ">
                    <div className="">
                      <label
                        htmlFor="dateOfResolution"
                        className="custm_label_fw"
                      >
                        Date of resolution
                      </label>
                      <input
                        value={defaultValues.dateOfResolution}
                        className="customInput "
                        id="dateOfResolution"
                        name="dateOfResolution"
                        min={defaultValues.dateOfOnset}
                        max={moment(today).format("YYYY-MM-DD")}
                        type="date"
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{
                          padding: "16px 12px",
                          width: "340px",
                          cursor: "not-allowed",
                        }}
                        onKeyDown={(e) => e.preventDefault()}
                        onChange={handleDefaultValuesChange}
                      />
                      {defaultValues.dateOfResolution?null:
                      <span className="placeholder-span" style={{width:"120px", height:"22px"}}>dd-mm-yyyy</span>
                      }
                    </div>
                    {
                      defaultValues.dateOfOnset === defaultValues.dateOfResolution ?
                      <div className="">
                      <label htmlFor="lastName" className="custm_label_fw">
                        Time of resolution (24 Hrs)
                      </label>
                      <input
                        value={defaultValues.timeOfResolution}
                        className="customInput "
                        id="timeOfResolution"
                        name="timeOfResolution"
                        type="time"
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "16px 12px", width: "340px" }}
                        onChange={handleDefaultValuesChange}
                        min={defaultValues.timeOfOnset}
                        onInput={validateTimeOfResolution}
                        />
                        {defaultValues.timeOfResolution?null:
                        <span className="placeholder-span" style={{width:"40px", height:"22px"}}>--:--</span>
                        }
                        <span style={{color:"red", fontSize:"14px"}}>
                          {showTimeError? timeError : null}
                        </span>
                    </div>
                    :
                    <div className="">
                      <label htmlFor="lastName" className="custm_label_fw">
                        Time of resolution (24 Hrs)
                      </label>
                      <input
                        value={defaultValues.timeOfResolution}
                        className="customInput "
                        id="timeOfResolution"
                        name="timeOfResolution"
                        type="time"
                        placeholder="Enter Here"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "16px 12px", width: "340px" }}
                        onChange={handleDefaultValuesChange}
                      />
                      {defaultValues.timeOfResolution?null:
                        <span className="placeholder-span" style={{width:"40px", height:"22px"}}>--:--</span>
                        }
                    </div>
                    }

                  </div>
                  
                    <div className="d-md-flex d-lg-flex d-xxl-flex  flex-column gap-3 border p-3 rounded ">
                      <div className={`d-flex ${JustBtwn} flex-column flex-md-row`}>
                        <div className='mb-4 mb-lg-0 mb-md-0' >
                          <label htmlFor="causality">
                            Causality
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                          <select
                            value={defaultValues.causality_id}
                            className="selectTag new-select-tag"
                            id="lastName"
                            type="text"
                            name='causality_id'
                            style={{ padding: "16px 12px", width: "340px" }}
                            onChange={handleDefaultValuesChange}
                          >
                            <option value={"Select"}>{eventDtls?.causality_name}</option>
                            {causalities &&
                              causalities.map((i) => {
                                return (
                                  <option
                                    key={i.causality_id}
                                    value={i.causality_id}
                                  >
                                    {i.causality_name}
                                  </option>
                                );
                              })}
                          </select>
                          </div>
                        </div>
                        <div className='mb-4 mb-lg-0 mb-md-0'>
                          <label htmlFor="outCome">
                            Outcome
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">
                          <select
                            value={defaultValues.outcome_id}
                            className="selectTag new-select-tag"
                            id="lastName"
                            type="text"
                            name='outcome_id'
                            style={{ padding: "16px 12px", width: "340px" }}
                            onChange={handleDefaultValuesChange}
                          >
                            <option value={"Select"}>
                              {eventDtls?.outcome_name}
                            </option>
                            {outComes &&
                              outComes.map((i) => {
                                return (
                                  <option value={i.outcome_id} key={i.outcome_id}>
                                    {i.outcome_name}
                                  </option>
                                );
                              })}
                          </select>
                          </div>

                        </div>

                      </div>
                      <div className={`d-flex ${JustBtwn} flex-column flex-md-row `}>
                        <div className='mb-4 mb-lg-0 mb-md-0'>
                          <label htmlFor="actionTaken">
                            Action Taken For Study Vaccine
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">

                          <select
                            value={defaultValues.action_taken_id}
                            className="selectTag new-select-tag"
                            id="lastName"
                            type="text"
                            name='action_taken_id'
                            style={{ padding: "16px 12px", width: "340px" }}
                            onChange={handleDefaultValuesChange}
                          >
                            <option value={"Select"}>{eventDtls?.action_taken_name}</option>
                            {actnTakenOpts &&
                              actnTakenOpts.map((i) => {
                                return (
                                  <option
                                    key={i.action_taken_id}
                                    value={i.action_taken_id}
                                  >
                                    {i.action_taken_name}
                                  </option>
                                );
                              })}
                          </select>
                          </div>

                        </div>
                        <div className='mb-4 mb-lg-0 mb-md-0' >
                          <label htmlFor="actionTaken">
                            Action Taken For Adverse Event
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="custom_select_main">

                          <select
                            value={defaultValues.action_taken_for_adverse_event_id}
                            className="selectTag new-select-tag"
                            id="lastName"
                            type="text"
                            name='action_taken_for_adverse_event_id'
                            style={{ padding: "16px 12px", width: "340px" }}
                            onChange={handleDefaultValuesChange}
                          >
                            <option value={"Select"}>
                              {eventDtls?.action_taken_for_adverse_event_name}
                            </option>
                            {actionTakenforAe &&
                              actionTakenforAe.map((i) => {
                                return (
                                  <option value={i.action_taken_for_adverse_event_id} key={i.action_taken_for_adverse_event_id}>
                                    {i.action_taken_for_adverse_event_name}
                                  </option>
                                );
                              })}
                          </select>
                          </div>

                        </div>

                      </div>

                      <div className={`d-flex ${JustBtwn} flex-column flex-md-row `}>
                                                {/* Start Date input */}
                                                {flag!==true && (
                                                
                                                    <div className="start-end-date">
                                                        <label htmlFor="startDate" className="custm_label_fw">
                                                            <p className="adverse-auto">Treatment Start Date  
                                                            {defaultValues.dateOfResolution&&<span className="text-danger">*</span>}
                                                              </p>
                                                        </label>
                                                        <input
                                                            value={defaultValues?.start_date_of_treatment}
                                                            className=" selectTag"
                                                            id="start_date_of_treatment"
                                                            type="date"
                                                            placeholder="Enter Start Date"
                                                            aria-placeholder="#D4D4D4"
                                                            style={{ padding: "16px 12px", width: "340px" }}
                                                            onChange={handleStartDateChange}
                                                            min={defaultValues?.dateOfOnset}                
                                                        />
                                                    </div>
                                                )} 

                                                {/* End Date input */}
                                                {flag!==true && (
                                               
                                                    <div className="start-end-date">
                                                        <label htmlFor="endDate" className="custm_label_fw">
                                                            <p className="adverse-auto">Treatment End Date
                                                            {defaultValues.dateOfResolution&&<span className="text-danger">*</span>}

                                                            </p>
                                                        </label>
                                                        <input
                                                            value={defaultValues?.end_date_of_treatment}
                                                            className=" selectTag"
                                                            id="end_date_of_treatment"
                                                            type="date"
                                                            placeholder="Enter End Date"
                                                            aria-placeholder="#D4D4D4"
                                                            style={{ padding: "16px 12px", width: "340px" }}
                                                            onChange={handleEndDateChange}
                                                            min={defaultValues.start_date_of_treatment} // Set minimum date based on Start Date
                                                        />
                                                    </div>
                                                )} 

                      </div>
                        </div>
                   
                  {eventDtls?.serious_adverse_event_name ?
                    <Row className="d-lg-flex align-items-center">

                      <Col>
                        <label htmlFor="lastName">
                          Serious adverse event criteria
                        </label>
                      </Col>
                      <Col>
                        <span>
                          <button className="red_btn advesre-serious"> {eventDtls?.serious_adverse_event_name}</button>
                        </span>
                      </Col>
                    </Row>

                    :
                    <div className="text-start d-lg-flex flex-column justify-content-between">
                      <Row>
                        <div className="d-lg-flex justify-content-between my-2">
                          <Col><label htmlFor="search_block">Serious Adverse Criteria<span className="text-danger"></span></label></Col>
                          <Col>
                            <div className="search_block" id='search_block' >
                              <div className="orange_btn" onClick={handleDropDown} style={{ width: "350px", padding: "12px 14px" }}
                              > {btnTitle.length > 30 ? btnTitle.slice(0, 30) + "..." : btnTitle || 'Select Adverse Criteria'}
                                <img src="./images/icons/selectarrow.svg" alt="" />
                              </div>
                              {showPopup && <div className="search_main" onBlur={() => {
                                setTimeout(() => {
                                  if (showPopup) {
                                    setShowPopup(false)
                                  }
                                }, 200)
                              }}>
                                <div className='drop_down_for_search'>
                                  <input
                                    type="text"
                                    autoFocus
                                    value={searchTerm}
                                    onChange={handleSearch}
                                    placeholder="Search..."
                                  />
                                  <img className='sasd' src="./images/icons/search.svg" alt="" />
                                  <div className="eventlist_items">
                                    {saEvents &&
                                      saEvents.filter(i => {
                                        const event = i.serious_adverse_event_name || '';
                                        return event.toLowerCase().includes((searchTerm || '').toLowerCase())
                                      }).map((i, index) => {

                                        return (
                                          <ul className='aelistdropdown' key={index}>
                                            <li className={`${i.serious_adverse_event_name === btnTitle ? 'selectedOption' : ''}`} onClick={() => handleOption(i)}
                                            >{i.serious_adverse_event_name || 'Select Adverse Criteria'}</li>
                                          </ul>
                                        )
                                      })}
                                  </div>
                                </div>
                              </div>}
                            </div>
                          </Col>
                        </div>
                      </Row>
                    </div>
                  }
                  {eventDtls?.study_aebank_event_title !== null && <Row className="d-flex align-items-center">
                    <Col>
                      <label htmlFor="lastName">
                        Adverse event
                      </label>
                    </Col>
                    <Col>
                      <span>
                        <button className="orange_btn advesre-serious"> {eventDtls?.study_aebank_event_title}</button>
                      </span>
                    </Col>
                  </Row>}
                  <div className="advEventGroup">
                    <div className="p-2 p-md-4 p-xxl-4 bg-light rounded eventClassificationDiv">
                      <div className="custm-radio-styl reviewlist">
                        {((eventDtls?.study_case_definition == EVENT_CLASSIFICATION_AESI) || (eventDtls?.study_case_definition == EVENT_CLASSIFICATION_OTHER)) && (
                          <div className="reviewaetilte">
                            <div className="custm-radio-styl ">
                              <label
                                htmlFor="notmetcase"
                                style={{
                                  display: "flex",
                                  alignItems: "start",
                                }}
                              >
                                <input
                                  type="radio"
                                  id="notmetcase"
                                  checked
                                  style={{ width: "20px" }}
                                />
                                <span style={{ marginLeft: "10px" }}>
                                  <div className="custm-radio-styl">
                                    {eventDtls?.study_case_definition === EVENT_CLASSIFICATION_AESI
                                      ? 'Adverse Event of Special Interest'
                                      : eventDtls?.study_case_definition === EVENT_CLASSIFICATION_OTHER
                                        ? 'Other'
                                        : ''}
                                  </div>
                                </span>
                              </label>
                            </div>
                          </div>
                        )}

                        {eventDtls?.input_notes_aesi_others !== null &&
                          <div>
                            <input
                              value={notesChange}
                              id="Treatment"
                              type="text"
                              placeholder='Any treatment given'
                              className="border py-3 px-2 rounded w-100"
                              onChange={handleNotesChange}
                              style={{ marginTop: "12px", padding: "12px", height: "60px" }}
                            />
                          </div>
                        }
                        {eventDtls !== "" ? (
                          <div className="advEventGroup">
                            <div className="p-2 bg-light rounded eventClassificationDiv">
                              {eventDtls?.study_case_definition === EVENT_CLASSIFICATION_LEVEL_BRIGHTON ? (
                                <div className="accordianClass">
                                  <BrightonCase handleReset={handleReset} radioValue={radioValue} handleRadioBtn={handleRadioBtn} radioReset={radioReset} getEventDescId={getEventDescId} />
                                </div>

                              ) : eventDtls?.study_case_definition === EVENT_CLASSIFICATION_GRADE_CTCAE ? (
                                <Accordion >
                                  <GradeCase handleReset={handleReset} radioValue={radioValue} handleRadioBtn={handleRadioBtn} radioReset={radioReset} getEventDescId={getEventDescId} />
                                </Accordion>
                              ) : eventDtls?.study_case_definition === EVENT_CLASSIFICATION_AESI ?
                                <Accordion >
                                  <div className="fs-6" dangerouslySetInnerHTML={{ __html: getStudyAeDtls && getStudyAeDtls[0]?.other_case?.study_aesi_description.replace(/(?:\r\n|\r|\n)/g, '<br>') }}></div>
                                </Accordion>
                                : (
                                  ""
                                )}
                            </div>
                          </div>
                        ) : null}

                      </div>
                    </div>
                  </div>

                  {/*eventDtls?.any_treatment_given !== '' && eventDtls?.any_treatment_given !== null &&
                                        <div>
                                            <label htmlFor="Treatment" className="fw-bold fs-6">Treatment Given</label>
                                            <input
                                                value={eventDtls?.any_treatment_given}
                                                className="border py-3 px-2 rounded w-100"
                                                id="Treatment Given"
                                                placeholder="Enter Treatment Given"
                                                disabled="true"
                                            />
                                        </div>
                                                                */}

                  {reviewerComments && reviewerComments?.filter(i => i.user_persona === PRINCIPAL_INVESTIGATOR).length > 0 &&
                    <div>
                      <label htmlFor="Treatment" className="fw-bold fs-6">Treatment Given</label>
                      <div
                        className="border py-3 px-2 rounded w-100"

                      >
                        {
                          reviewerComments && reviewerComments?.map((i, index) => {
                            return (
                              i.user_persona === PRINCIPAL_INVESTIGATOR ?
                                <div className="d-flexflex-column">
                                  <div className="d-flex">
                                    <li></li>
                                    <div>{i.comment.charAt(0).toUpperCase() + i.comment.slice(1)}</div>
                                  </div>
                                  <p className=" updateae_cmnt_date">
                                    Treated On: {moment(i.createdAt).format("DD/MM/YYYY HH:mm:ss")}
                                  </p>
                                </div>
                                : "")
                          })
                        }
                      </div>
                    </div>
                  }

                  <div>
                    <label htmlFor="Treatment" className="fw-bold fs-6">Comments</label>
                    <input
                      className="border py-3 px-2 rounded w-100"
                      id="Treatment Given"
                      placeholder="Enter Comments"
                      onChange={handleTreatment}
                    />
                  </div>        
                                                   <div>
  <label htmlFor="attachment" className="fw-bold fs-6">
    Attachments
  </label>
  {eventDtls?.documents?.length > 0 ? (
    <div style={{ width: "340px" }}>
      {eventDtls?.documents?.map((document) => {
        const fileExtension = (document.document_name || '').split('.').pop().toLowerCase();
        let icon = getIcon(fileExtension);
        extensions = fileExtension;

        return (
          <div key={document.document_id} className="card my-custom-class">
            <div className="d-flex flex-row justify-content-between">
              <p className="col-10" title={document.document_name ? document.document_name : ''}>
                {document.document_name
                  ? document.document_name.length > 30
                    ? `${document.document_name.slice(0, 30)}...`
                    : document.document_name
                  : ''}
              </p>
              <img
  height="30px"
  width="50px"
  src={icon}
  alt=""
  onClick={() => {
    if (['xlsx', 'xls'].includes(extensions)) {
      window.open(document.document_url, '_blank');
    } else {
      handleViewClick(document);
    }
  }}
  style={{ cursor: "pointer" }}
/>

            </div>
          </div>
        );
      })}
    </div>
  ) : (
    <p>No documents found</p>
  )}
  {selectedDocument && !['xlsx', 'xls'].includes(extensions) && (
    <Modal show={selectedDocument !== null} onHide={handleCloseModal} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isImage(extensions) ? (
          <img
            src={selectedDocument.document_url}
            title="Preview"
            width="100%"
            height="500px"
            style={{ border: '1px solid #ccc', width: "100%" }}
          />
        ) : (
          <iframe
            src={selectedDocument.document_url}
            title="Preview"
            width="100%"
            height="500px"
            style={{ border: '1px solid #ccc' }}
          />
        )}
      </Modal.Body>
    </Modal>
  )}
</div>
                </Col>
              </div>

              <div className="registrationStepsFooter ps-3" >
                <button className="white_btn white_btn_back white_btn_mbl px-md-4 px-lg-4" onClick={() => {
                    dispatch(resetEventDetails())
                    dispatch(resetSubjectProfile())
                    navigate('/pirejectedevents')
                  }}>
                  Back
                </button>
                

                  <button
                    id={'sendBack'}
                    className="orange_btn orange_btn_mbl"
                    onClick={handleUpdate}
                    disabled={defaultValues.causality_id === '' || defaultValues.outcome_id === "" || defaultValues.action_taken_for_adverse_event_id === "" || defaultValues.action_taken_id === "" || defaultValues.dateOfResolution == "" || defaultValues.dateOfOnset == "" || defaultValues.timeOfOnset == "" || defaultValues.timeOfResolution == "" ||
                      defaultValues?.start_date_of_treatment =='' ||
                      (buttonDisable && defaultValues?.start_date_of_treatment == null) ||
                      defaultValues?.end_date_of_treatment =='' ||
                      (buttonDisable && defaultValues?.end_date_of_treatment == null)
                  }
                  >
                    Update
                  </button>
                
              </div>
            </Row>
            </Container>
          }

        </div>
        <PopUpModal
          handleClose={handleClosePopup}
          open={open}
          title={"Success!"}
          msg={"Adverse event updated successfully!"}
          close={"Close"}
          actionbtn={"Done"}
          onConfirm={handleReviewActions}
        />
      </div>
      {loading && <Loader />}
    </>
  );
};

export default PIRejectEventsEdit;